import { Button } from "@mui/material";
import styles from "./LinkButton.module.scss";
import withStyles from '@mui/styles/withStyles';

const ButtonCustom  =  withStyles({
    root: {
        border: "1px solid transparent",
        borderRadius: "6px",
        color: "var(--standard-white)",
        backgroundColor: "var(--standard-jade-500)",
        textTransform: "none",
        fontSize: "14px",
        height: "32px",
        "&:hover": {
            transition: "background-color .3s,border-color .3s,box-shadow .3s,color .3s else-in",
            backgroundColor: "var(--standard-jade-700)",
            borderColor: "var(--standard-jade-700)",
            boxShadow: "0 1px 2.5px 0 rgb(0 0 0 / 26%), 0 1px 5px 0 rgb(0 0 0 / 16%)",
            textTransform: "none",
        },
        "&:disabled": {
            color: "gray",
            borderColor: "transparent"
        }
    },
    label: {

    }
})(Button);


export default function SolidLinkButton(props) {
    return <ButtonCustom {...props} className={props.className? props.className + " " + styles.Root : styles.Root}>{props.children}</ButtonCustom>
}